module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"subscribe":"Подписаться","follow_back":"Подписаться в ответ","you_subscribed":"Вы подписаны","request_send":"Запрос отправлен"}}')
  delete Component.options._Ctor
}
